export class DtoCodigoDescripcion {
    Codigo: string = "";
    Descripcion: string = "";
}